import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "table__row table__row--body" }
const _hoisted_2 = { class: "table__col table__col--icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "table__col table__col--name" }
const _hoisted_5 = { class: "table__col table__col--stat" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_8 = { class: "table__col table__col--stat" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_11 = { class: "table__col table__col--stat" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_14 = { class: "table__col table__col--stat" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_17 = { class: "table__col table__col--stat" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)
const _hoisted_20 = { class: "table__col table__col--desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_shiny_border = _resolveDirective("shiny-border")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@/assets/soldier_icons/' + _ctx.item.icon)
      }, null, 8, _hoisted_3),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.item.name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 1)[0]), 1),
      _hoisted_6,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 1)[1]), 1),
      _hoisted_7,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 1)[2]), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 2)[0]), 1),
      _hoisted_9,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 2)[1]), 1),
      _hoisted_10,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 2)[2]), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 3)[0]), 1),
      _hoisted_12,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 3)[1]), 1),
      _hoisted_13,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 3)[2]), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 4)[0]), 1),
      _hoisted_15,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 4)[1]), 1),
      _hoisted_16,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 4)[2]), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 5)[0]), 1),
      _hoisted_18,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 5)[1]), 1),
      _hoisted_19,
      _createElementVNode("span", null, _toDisplayString(_ctx.calculateStatsByLvl(_ctx.item.statsMod, 5)[2]), 1)
    ]),
    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.item.perk), 1)
  ])), [
    [_directive_shiny_border, {
			height: 2,
			padding: 12,
			hoverRgbaColor: [51, 51, 51, 0.76],
		}],
    [_directive_ripple]
  ])
}